"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const form_1 = require("../form");
const __1 = require("../");
function useForm() {
    const dispatch = (0, __1.useAppDispatch)();
    const fields = (0, __1.useAppSelector)(state => state.fields) || {};
    return {
        fields,
        setField: (name, value) => dispatch((0, form_1.setFields)([[name, value]])),
        setFields: (setters) => dispatch((0, form_1.setFields)(setters)),
    };
}
exports.default = useForm;
